import React from 'react';
import { Icon } from 'tea-component';
import fileDefaultSrc from '../QAInput/imgs/deep_think.svg';
import defaultSrc from '@/pages/aigc/assets/svg/default-file-icon.svg';
// import RenderImage from '../../ChatPage/components/TabComponent/RenderImage';
import ImagePreview from '@/pages/aigc/components/ImagePreview';
interface ImageItemProps {
  file: {
    id: string;
    name: string;
    previewName?:string;
    status: 'success' | 'uploading' | 'error'  | 'pending';
    fileSrc: string;
    previewUrl: string;
  };
}

const ImageItem: React.FC<ImageItemProps> = ({ file }) => {

  const renderImgStatus = () => {
    const { status } = file;
    if (status === 'uploading' || status === 'pending') {
      return (
        <>
          <Icon
            size="l"
            type="loading"
            className="dba-file-loading dba-file-loading-img"
          />
        </>
      );
    }

    if (status === 'error') {
      return (
        <>
          <Icon
            size="l"
            type="error"
            className="dba-file-loading dba-file-error-img"
          />
        </>
      );
    }

    return null;
  };

  return (
    <div className="dba-file-img">
      <ImagePreview
        src={file?.fileSrc || file?.previewUrl || fileDefaultSrc}
        name={file?.previewName || ''}
        defaultSrc={defaultSrc}
        haveLoading={true}
      />
      {renderImgStatus()}
    </div>
  );
};

export default ImageItem;